import { render, staticRenderFns } from "./PortfolioValueChart.vue?vue&type=template&id=daab59be&"
import script from "./PortfolioValueChart.vue?vue&type=script&lang=js&"
export * from "./PortfolioValueChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports